module.exports = ".formulario-modelo-td {\n  margin-bottom: 1.2rem; }\n"